import { sym } from "rdflib";
import { fetchNode } from "../index.js";
import { ldp, rdf } from "../namespaces/index.js";
/**
 * Provides common functionality useful for many rdflib-based data modules
 */
export class ModuleSupport {
    constructor(config) {
        this.store = config.store;
        this.fetcher = config.fetcher;
        this.updater = config.updater;
    }
    /**
     * Nullsafe fetching of a node
     * @param node - A node to fetch, or null to do nothing at all
     */
    async fetchNode(node) {
        return fetchNode(this.fetcher, node);
    }
    /**
     * Fetch all the given nodes in parallel
     * @param nodes
     */
    async fetchAll(nodes) {
        return Promise.all(nodes.map((it) => this.fetchNode(it)));
    }
    /**
     * Checks whether the resource identified by the given URL is a LDP container
     * @param storageUrl - The URL to check
     * @returns true if it is a container, false otherwise
     */
    async isContainer(storageUrl) {
        const storageNode = sym(storageUrl);
        await this.fetcher.load(storageNode.value);
        return this.store.holds(storageNode, rdf("type"), ldp("Container"), storageNode.doc());
    }
}
//# sourceMappingURL=ModuleSupport.js.map